export default __webpack_public_path__ + "media/pitch.157edace.svg";